const modules = import.meta.glob<{ default: string }>('./brezany-*.jpg', { eager: true });

export const brezanyImages = Object.keys(modules)
  .sort((a, b) => {
    const na = parseInt(a.match(/brezany-(\d+)/)?.[1] || '0');
    const nb = parseInt(b.match(/brezany-(\d+)/)?.[1] || '0');
    return na - nb;
  })
  .map(k => modules[k].default);
